/*
 * Copyright (C) 2018 Bruno López Trigo
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import {
    ExpansionPanel,
    ExpansionPanelSummary,
    Typography,
    Input,
    ExpansionPanelDetails,
    List,
    ListItem,
    TableHead,
    TableRow,
    TableCell,
    TableBody
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import Table from "@material-ui/core/Table";

const styles = theme => ({
    panel: {
        display:"block",
        marginTop: 10
    },
    attName: {
        width: "90%"
    },
    attValue: {
        float:"right",
    },
    input: {
        marginLeft: 5,
        marginRight: 5,
        width: "100%"
    },
    interval: {
        marginLeft: 20,
        width: "40%"
    },
    add: {
        marginTop: 10,
        backgroundColor: "#4caf50",
        "&:hover": {
            backgroundColor: "#357a38"
        }
    },
    delete: {
        backgroundColor: "#ff3d00",
        "&:hover": {
            backgroundColor: "#b22a00"
        }
    },
    addIcon: {
        fill: "white"
    },
    fabProgress: {
        color: "#357a38",
        position: "absolute",
        top: 6,
        left: -3,
        zIndex: 1
    },
    fabProgressDelete: {
        color: "#b22a00",
        position: "absolute",
        top: -2,
        left: -3,
        zIndex: 1
    },
    centeredButton: {
        display: "flex",
        justifyContent: "center"
    },
    wrapper: {
        position: "relative"
    }
});

class Attribute extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: null
        };
    }

    handleChangePanel = panel => (event, expanded) => {
        this.setState({
            expanded: expanded ? panel : false
        });
    };

    render() {
        debugger
        const { classes } = this.props;
        const { expanded } = this.state;

        return (
            <ExpansionPanel
                className={classes.panel}
                expanded={expanded === this.props.att.id}
                onChange={this.handleChangePanel(this.props.att.id)}
            >
                <ExpansionPanelSummary expandIcon={<ExpandMore />}>
                    <Typography variant="body1" className={classes.attName}>
                        {this.props.att.name}
                    </Typography>
                    <Typography variant="body1" className={classes.attValue}>
                        {this.props.instance.attributes[this.props.index + 1].value}
                    </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    {expanded === this.props.att.id && (
                        <List style={{width:"100%"}} component="nav">
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            {this.props.language.labels[this.props.language.id].nameOfProperty}
                                        </TableCell>
                                        <TableCell>
                                            {this.props.language.labels[this.props.language.id].minimum}
                                        </TableCell>
                                        <TableCell>
                                            {this.props.language.labels[this.props.language.id].maximum}
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {this.props.att.type === "numericAtt" &&
                                this.props.att.properties.map(prop => {
                                    return (
                                            <TableRow>
                                                <TableCell>
                                                    {prop.name}
                                                </TableCell>
                                                <TableCell>
                                                    {prop.interval.left.toFixed(2)}
                                                </TableCell>
                                                <TableCell>
                                                    {prop.interval.right.toFixed(2)}
                                                </TableCell>
                                            </TableRow>
                                    );
                                })}
                                </TableBody>
                            </Table>
                            {this.props.att.type === "categoricAtt" &&
                            this.props.att.properties.map((prop, index) => {
                                return (
                                    <ListItem key={prop.name}>
                                        <Input
                                            value={prop.value}
                                            id={index.toString()}
                                            name={this.props.index.toString()}
                                            onChange={this.props.changeCategoricName}
                                            error={
                                                this.props.errorsPropertyName[this.props.index] &&
                                                this.props.errorsPropertyName[this.props.index][index]
                                            }
                                        />
                                    </ListItem>
                                );
                            })}
                        </List>
                    )}
                </ExpansionPanelDetails>
            </ExpansionPanel>
        );
    }
}

Attribute.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Attribute);
